export interface Site {
  siteTitle: string,
  firstName: string,
  lastName: string,
  company: string,
  phoneCode: string,
  phoneNumber: string,
  verificationType: string,
  email: string,
  package: string,
  userId: string,
  siteLoaded: boolean
}

export const siteDefault: Site = {
  siteTitle: "",
  firstName: "",
  lastName: "",
  company: "",
  phoneCode: "",
  phoneNumber: "",
  verificationType: "",
  email: "",
  package: "",
  userId: "",
  siteLoaded: false
};

export enum SiteCookie {
  Cart = "Cart",
  SnapScanRedirect = "SnapScanRedirect"
}
